// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-photo {
	position: relative;
}

.profile-photo img {
	width: 64px;
	height: 64px;
	overflow: hidden;
	border-radius: 32px;
}

.profile-photo .loading-indicator {
	position: absolute;
	top: 0;
	left: 2px;
	margin-top: -1px;
	color: #fff !important;
}

.profile-photo .error-message {
	position: absolute;
	top: 68px;
	left: 0;
	color: #AB1F2B;
	white-space: nowrap;
	font-weight: 600;
}

.profile-photo .upload-button {
	background: none !important;
	border: none;
	position: absolute !important;
	z-index: 1;
	left: 0;
	top: 0;
	bottom: 0;
	right: 0;
}

.profile-photo .upload-button .upload-banner {
	position: absolute;
	left: 0;
	bottom: 0;
	height: 30px;
	width: 100%;
	background: none;
	line-height: 30px;
	opacity: .8;
	border-bottom-left-radius: 32px;
	border-bottom-right-radius: 32px;
	text-align: center;
}

.profile-photo .upload-button:hover .upload-banner {
	background: #000;
}

.profile-photo .upload-button:hover .upload-banner i {
	opacity: 1;
}

.profile-photo .upload-button .upload-banner i {
	text-shadow: -1px 1px #333;
	font-size: 14px;
	line-height: 30px;
	color: #FFF;
	opacity: 0;
}`, "",{"version":3,"sources":["webpack://./src/widgets/MyDataHelps/Dashboard/ProfilePhoto.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,SAAS;CACT,gBAAgB;CAChB,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,OAAO;CACP,cAAc;CACd,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;CAC3B,YAAY;CACZ,6BAA6B;CAC7B,UAAU;CACV,OAAO;CACP,MAAM;CACN,SAAS;CACT,QAAQ;AACT;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,SAAS;CACT,YAAY;CACZ,WAAW;CACX,gBAAgB;CAChB,iBAAiB;CACjB,WAAW;CACX,+BAA+B;CAC/B,gCAAgC;CAChC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,iBAAiB;CACjB,WAAW;CACX,UAAU;AACX","sourcesContent":[".profile-photo {\n\tposition: relative;\n}\n\n.profile-photo img {\n\twidth: 64px;\n\theight: 64px;\n\toverflow: hidden;\n\tborder-radius: 32px;\n}\n\n.profile-photo .loading-indicator {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 2px;\n\tmargin-top: -1px;\n\tcolor: #fff !important;\n}\n\n.profile-photo .error-message {\n\tposition: absolute;\n\ttop: 68px;\n\tleft: 0;\n\tcolor: #AB1F2B;\n\twhite-space: nowrap;\n\tfont-weight: 600;\n}\n\n.profile-photo .upload-button {\n\tbackground: none !important;\n\tborder: none;\n\tposition: absolute !important;\n\tz-index: 1;\n\tleft: 0;\n\ttop: 0;\n\tbottom: 0;\n\tright: 0;\n}\n\n.profile-photo .upload-button .upload-banner {\n\tposition: absolute;\n\tleft: 0;\n\tbottom: 0;\n\theight: 30px;\n\twidth: 100%;\n\tbackground: none;\n\tline-height: 30px;\n\topacity: .8;\n\tborder-bottom-left-radius: 32px;\n\tborder-bottom-right-radius: 32px;\n\ttext-align: center;\n}\n\n.profile-photo .upload-button:hover .upload-banner {\n\tbackground: #000;\n}\n\n.profile-photo .upload-button:hover .upload-banner i {\n\topacity: 1;\n}\n\n.profile-photo .upload-button .upload-banner i {\n\ttext-shadow: -1px 1px #333;\n\tfont-size: 14px;\n\tline-height: 30px;\n\tcolor: #FFF;\n\topacity: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
